// extracted by mini-css-extract-plugin
export default {"container":"Delivery_container__lGyF+"};